import { Badge } from '@/components/ui/badge';
import { industryLabel, regionLabel } from '../constants';
import type { Company } from '../types';

export type CompanyProfile = Pick<Company, 'industry' | 'region' | 'technologies'>;

/**
 * What the client is (ADR-108) — industry, region and stack — as read-only
 * label/value cells. Shown on the company itself and on its leads.
 */
export function CompanyProfileFields({ profile }: { profile: CompanyProfile }) {
  return (
    <>
      <ProfileCell label="Industry">
        {profile.industry ? industryLabel(profile.industry) : '—'}
      </ProfileCell>
      <ProfileCell label="Region">{profile.region ? regionLabel(profile.region) : '—'}</ProfileCell>
      <ProfileCell label="Technologies" className="sm:col-span-2">
        {profile.technologies.length ? (
          <div className="flex flex-wrap gap-1">
            {profile.technologies.map((tech) => (
              <Badge key={tech} variant="secondary" className="font-normal">
                {tech}
              </Badge>
            ))}
          </div>
        ) : (
          '—'
        )}
      </ProfileCell>
    </>
  );
}

function ProfileCell({
  label,
  children,
  className,
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <p className="text-muted-foreground text-xs font-medium uppercase">{label}</p>
      <div className="mt-1 text-sm break-words whitespace-pre-wrap">{children}</div>
    </div>
  );
}
